export const PRODUCT_IMAGE_FIELDS = [
  'image',
  'image_2',
  'image_3',
  'image_4',
  'image_5',
  'image_6',
]

export const MAX_PRODUCT_IMAGES = PRODUCT_IMAGE_FIELDS.length

export const PRODUCT_IMAGE_FILE_KEYS = PRODUCT_IMAGE_FIELDS.map((field, index) =>
  index === 0 ? 'image_file' : `${field}_file`
)

export const PRODUCT_IMAGE_LABELS = [
  'Principal',
  'Imagen 2',
  'Imagen 3',
  'Imagen 4',
  'Imagen 5',
  'Imagen 6',
]

/** @param {Record<string, unknown>|null|undefined} product */
export function getProductImages(product, placeholder = '') {
  if (!product) return placeholder ? [placeholder] : []
  const urls = PRODUCT_IMAGE_FIELDS
    .map((field) => product[field])
    .filter((url) => url != null && String(url).trim() !== '')
  const extras = Array.isArray(product.extra_images)
    ? product.extra_images.filter((url) => url != null && String(url).trim() !== '')
    : []
  urls.push(...extras)
  if (urls.length === 0 && placeholder) return [placeholder]
  return urls
}

/** @param {number} index */
export function getProductImageField(index) {
  return PRODUCT_IMAGE_FIELDS[index] ?? null
}

/** @param {number} index */
export function getProductImageFileKey(index) {
  return PRODUCT_IMAGE_FILE_KEYS[index] ?? null
}
